import React from "react";
import Header from "../pages/header"; 
import Footer from "../pages/footer"; 

// Placeholder images - Replace with your actual imports
import blog_hero from "../../img/about_2.jpg"; // Use a "laptop/coffee" style image
import author_img from "../../img/testimonial_2.jpg"; 

const RemoteWorkTrends = () => {
  return (
    <>
      <Header path="/blog" />

      {/* --- 1. PAGE HEADER --- */}
      <div className="container-fluid py-5 bg-dark page-header mb-5">
        <div className="container my-5 pt-5 pb-4">
          <h1 className="display-3 text-white mb-3 animated slideInDown">Remote Work Trends in 2025</h1>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb text-uppercase">
              <li className="breadcrumb-item"><a href="/">Home</a></li>
              <li className="breadcrumb-item"><a href="#Blog">Blog</a></li>
              <li className="breadcrumb-item"><a href="#Remote Work">Remote Work</a></li>
            </ol>
          </nav>
        </div>
      </div>

      {/* --- 2. ARTICLE CONTENT --- */}
      <div className="container-fluid py-5">
        <div className="container">
          <div className="row g-5">
            
            {/* Left Column: Main Article */}
            <div className="col-lg-8">
              
              {/* Meta Data */}
              <div className="d-flex align-items-center mb-4">
                <img 
                    src={author_img} 
                    alt="Author" 
                    className="rounded-circle me-3" 
                    style={{ width: "50px", height: "50px", objectFit: "cover" }} 
                />
                <div>
                    <h6 className="mb-0 text-dark">Written by Jane Smith</h6>
                    <small className="text-muted">Updated: Oct 15, 2025 • 6 min read</small>
                </div>
                <div className="ms-auto d-none d-md-block">
                    <span className="badge bg-secondary me-2">#RemoteLife</span>
                    <span className="badge bg-secondary">#FutureOfWork</span>
                </div>
              </div>

              {/* Featured Image */}
              <div className="mb-5 position-relative">
                <img 
                    className="img-fluid rounded w-100 shadow-sm" 
                    src={blog_hero} 
                    alt="Remote Work Office" 
                    style={{ maxHeight: "400px", objectFit: "cover" }}
                />
              </div>

              {/* Article Body */}
              <article className="article-body">
                <p className="lead mb-4">
                  The "Great Resignation" has settled, but the demand for flexibility hasn't. 
                  In 2025, remote work isn't just a perk; it's a non-negotiable for top talent. 
                  Here is how the landscape is shifting.
                </p>

                {/* HIGHLIGHT BOX: KEY STATS */}
                <div className="row g-3 my-5">
                    <div className="col-md-4">
                        <div className="p-4 bg-light rounded text-center border h-100">
                            <h2 className="text-primary fw-bold display-4">98%</h2>
                            <p className="mb-0 small text-muted">of workers want to work remotely at least some of the time.</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 bg-light rounded text-center border h-100">
                            <h2 className="text-primary fw-bold display-4">16%</h2>
                            <p className="mb-0 small text-muted">of companies are now fully remote (no physical HQ).</p>
                        </div>
                    </div>
                    <div className="col-md-4">
                        <div className="p-4 bg-light rounded text-center border h-100">
                            <h2 className="text-primary fw-bold display-4">22%</h2>
                            <p className="mb-0 small text-muted">increase in productivity reported by remote teams.</p>
                        </div>
                    </div>
                </div>

                <h2 className="mb-3">1. The Rise of "Structured Hybrid"</h2>
                <p>
                  Gone are the days of "come in when you want." Companies are moving toward <strong>Structured Hybrid</strong> models. 
                  This means teams agree on specific "anchor days" (usually Tuesday/Thursday) to collaborate in person, while leaving the rest for deep, focused work at home.
                </p>

                <h2 className="mb-3 mt-5">2. Asynchronous Communication is King</h2>
                <p>
                  With teams spread across time zones, the 9-to-5 is dead. Companies are adopting <em>Async-First</em> communication. 
                  This reduces Zoom fatigue and allows employees to work during their peak productivity hours.
                </p>
                <blockquote className="blockquote bg-white border-start border-5 border-primary p-4 shadow-sm my-4 rounded">
                    <p className="mb-0 fst-italic">"The future of work is not about where you work, but <strong>how</strong> you work. Trust is the new currency."</p>
                    <footer className="blockquote-footer mt-2">CEO of TechGlobal</footer>
                </blockquote>

                <h2 className="mb-3 mt-5">3. Digital Nomad Visas</h2>
                <p>
                    Countries are competing for talent. Over 50 countries (including Spain, Portugal, and Japan) now offer specific 
                    <strong> Digital Nomad Visas</strong>, allowing remote workers to live there legally tax-free or with reduced rates for a year.
                </p>

                <h2 className="mb-3 mt-5">4. AI-Augmented Collaboration</h2>
                <p>
                    Tools like ChatGPT and Copilot are integrating into Slack and Teams to summarize meetings you missed. 
                    This ensures that remote workers never feel "out of the loop."
                </p>

                <hr className="my-5" />
                
                <div className="bg-primary bg-opacity-10 rounded p-5 text-center">
                    <h3 className="mb-3">Looking for a Remote Job?</h3>
                    <p className="mb-4">We have over 5,000 active remote listings waiting for you.</p>
                    <a href="/jobs?type=remote" className="btn btn-primary py-3 px-5">Browse Remote Jobs</a>
                </div>
              </article>
            </div>

            {/* Right Column: Sidebar */}
            <div className="col-lg-4">
                
                {/* Search Widget */}
                <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                    <div className="input-group">
                        <input type="text" className="form-control p-3" placeholder="Search articles..." />
                        <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
                    </div>
                </div>

                {/* Popular Topics */}
                <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                    <h4 className="mb-4">Popular Topics</h4>
                    <ul className="list-group list-group-flush">
                        <li className="list-group-item bg-transparent px-0"><a href="#" className="text-decoration-none text-muted"><i className="bi bi-arrow-right text-primary me-2"></i>Work from Home Tips</a></li>
                        <li className="list-group-item bg-transparent px-0"><a href="#" className="text-decoration-none text-muted"><i className="bi bi-arrow-right text-primary me-2"></i>Digital Nomad Guide</a></li>
                        <li className="list-group-item bg-transparent px-0"><a href="#" className="text-decoration-none text-muted"><i className="bi bi-arrow-right text-primary me-2"></i>Zoom Fatigue</a></li>
                        <li className="list-group-item bg-transparent px-0"><a href="#" className="text-decoration-none text-muted"><i className="bi bi-arrow-right text-primary me-2"></i>Hybrid Policies</a></li>
                    </ul>
                </div>

                {/* FEATURED REMOTE JOBS (Contextual Sidebar) */}
                <div className="mb-5 wow slideInUp" data-wow-delay="0.1s">
                    <h4 className="mb-4">Top Remote Roles</h4>
                    {[
                        {title: "React Developer", company: "TechFlow", salary: "$120k"},
                        {title: "Content Manager", company: "WriteNow", salary: "$70k"},
                        {title: "Customer Success", company: "HelpDesk", salary: "$55k"},
                    ].map((job, i) => (
                        <div className="d-flex align-items-center mb-3 bg-white p-3 rounded shadow-sm border hover-shadow" key={i} style={{cursor: 'pointer'}}>
                            <div className="bg-success bg-opacity-10 d-flex align-items-center justify-content-center rounded text-success" style={{width: '45px', height: '45px'}}>
                                <i className="fa fa-wifi"></i>
                            </div>
                            <div className="ps-3">
                                <h6 className="mb-1">{job.title}</h6>
                                <small className="text-muted d-block">{job.company}</small>
                                <small className="text-primary fw-bold">{job.salary}</small>
                            </div>
                        </div>
                    ))}
                     <a href="/jobs" className="btn btn-outline-primary w-100 py-2">See All Remote Jobs</a>
                </div>
            </div>
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default RemoteWorkTrends;